module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/clock-85f3b5f5fc19be15440f248b17571087.svg";